import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAPklEQVR42oWNMQoAIAwD+/9f6uCiOItNGyu4uGggHIHACd+BuCpRK9Fa9HDv3kmzOIzBmRJnzhe1FDoA+SkWPOB85Ij5ry0AAAAASUVORK5CYII="};
